import { t } from "ttag";

import { Text } from "@/shared/ui";

export const CompoundedMedicationDisclaimer = () => (
  <Text color="light-neutral" size="x-small" italic>
    {t`LevelsRx does not manufacture compounded medications. Actual product appearance and labeling of the medication you receive will differ from website images.`}
  </Text>
);
